import React from "react";
// React Bootstrap
import { Container, Col, Row, Image } from "react-bootstrap";
// Utils
import { handleOnImg404 } from "../../../utils";
// Contexto
import { categoriaMisiones } from "../../../contexto";

const MisionInfo = ({ datosMision, idProvincia }) => {
  return (
    <Container fluid className="shadow-lg my-5 ">
      <Row>
        <Col>
          <Image
            className="img-fluid-detalle"
            variant="top"
            src={datosMision.photo ? `${process.env.REACT_APP_API_URL}/download/provincias/${idProvincia}/` : `${process.env.REACT_APP_API_URL}/download/provincias/${idProvincia}/`}
            onError={(e) => handleOnImg404(e, "/images/logoSTJ.png")}
            alt="misionImg"
          />
        </Col>
        <Col className="d-flex align-items-center">
          <Container>
            <Row noGutters>
              <h5>{datosMision?.name || <small>No especificado</small>}</h5>
            </Row>
            <Row noGutters>
              {datosMision?.country || datosMision?.place ? (
                <h5>{`${datosMision?.country} - ${datosMision?.place}`}</h5>
              ) : (
                <h5>
                  <small>No especificado</small>
                </h5>
              )}
            </Row>
            <Row noGutters>
              {datosMision?.type ? (
                <h5> {`${datosMision?.type} ${(!(datosMision?.isCollaborative) ? " STJ" : '')}`}</h5>
              ) : (
                <h5>
                  <small>No especificado</small>
                </h5>
              )}
            </Row>
            {/* <Row noGutters>
              {datosMision?.category ? (
                <h5>{`${categoriaMisiones[datosMision?.category]}`}</h5>
              ) : (
                <h5>
                  <small>No especificado</small>
                </h5>
              )}
            </Row> */}
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default MisionInfo;
